const phoneValidator = () => {
    return regexValidator(/^[+]{0,1}[\d\s]{8,14}$/, 'Must be a valid phone number');
};
const regexValidator = (regex, errorText) => (str) => {
    const isValid = regex.test(str);
    return {
        isValid,
        message: isValid ? '' : errorText
    };
};
const numberValidator = (min, max) => (num) => {
    const isValid = num >= min && num <= max;
    return {
        isValid,
        message: isValid ? '' : `Must be between ${min} and ${max}`
    };
};
const emptyValidator = () => {
    return {
        isValid: true,
        message: ''
    };
};
const requiredValidator = (value) => {
    let isValid = true;
    if (typeof value === 'string') {
        isValid = value.trim().length > 0;
    }
    else {
        isValid = !!value;
    }
    return {
        isValid,
        message: isValid ? '' : 'Field is required'
    };
};
export { emptyValidator, numberValidator, phoneValidator, regexValidator, requiredValidator };
//# sourceMappingURL=formrValidators.js.map